import React, { useContext, useState } from "react";
import {
  Button,
  Text,
  Card,
  Collapsible,
  // Link,
  List,
  ProgressBar,
  SkeletonBodyText,
  InlineStack,
  Tooltip,
  AppProvider,
  Divider,
  Box,
} from "@shopify/polaris";
import { ThemeProvider } from "asset/styles/themeStyle";
import { PrivateContext } from "lib/context";
import { baseHelper } from "lib/helpers";
import { StyledCardHeader } from "asset/styles/globalStyle";

import config from "configuration";
import content from "app/setup/modules/operator/features/branding/subFeatures/color/subFeatureItems/content";
import { StyledPlanCard, InnerCard } from "./planCardStyle";

const OperatorPlanCard = () => {
  const { cms, currentUser, isLoading } = useContext(PrivateContext);
  const [openPlanCard, setOpenPlanCard] = useState(true);

  const isMaison = currentUser.shop === "maisonflaneur";

  const { plan = {}, products = {}, vendors = {} } = currentUser;

  const { code = "", name = "", price = "", isPAYE = false } = plan; // , isChargebee = false
  const { max: maxProduct = "", used = "" } = products;
  const { max: maxVendor = "", associated = "" } = vendors;
  const planURL = "/update/plan"; // isChargebee ? "/update/plan" : "/plan";

  if (isLoading) {
    return <SkeletonBodyText lines={3} />;
  }

  const isPayeData = !!(plan && plan.paye && plan.paye.calculatedPrice);

  const chargeCurrency = isMaison ? currentUser.moneyFormat : "$";
  const payeRate = isMaison ? "2.5" : "3";

  return (
    <AppProvider>
      <ThemeProvider>
        <Card>
          <InlineStack align="space-between">
            <Text variant="headingSm" as="p">{isPAYE ? "Your Plan" : cms("common.label.planCard.title")}</Text>
            <Button variant="plain" disclosure={openPlanCard ? "up" : "down"} onClick={() => setOpenPlanCard(!openPlanCard)}>
              {openPlanCard ? cms("common.label.hide") : cms("common.label.show")}
            </Button>
          </InlineStack>
          <Collapsible
            open={openPlanCard}
            id="collapsiblePlanCard"
            transition={{ duration: "150ms", timingFunction: "ease" }}
          >
            <Box paddingBlock="400">
              <Divider />
            </Box>
            <InnerCard className="inner-card">
              <div className="stack-wrapper plan">
                <InlineStack blockAlign="center" align="space-between">
                  <div>
                    <Text as="span" fontWeight="semibold">
                      {isPAYE ? "Pay as You Earn (PAYE)" : baseHelper.ucFirst(baseHelper.getPlanBadge(code || name))}
                    </Text>
                    <Text variant="bodySm" as="p">
                      <Text as="span" tone="subdued">
                        {cms("common.label.planCard.currentPlan")}
                      </Text>

                      {/* <div>
                          <Link url={planURL}>
                          <Text as="span" fontWeight="semibold">{cms("common.button.upgrade")}</Text>
                          </Link>
                          </div> */}
                    </Text>
                  </div>
                  {isPAYE && isPayeData && (
                    <div>
                      <List type="bullet">
                        <List.Item>
                          <b>Charge* (as calculated till today):</b> ${plan.paye.calculatedPrice}
                        </List.Item>
                        <List.Item>
                          <b>Billing Term Start Date:</b> {baseHelper.formatDate(plan.paye.startTermDate)}
                        </List.Item>
                        <List.Item>
                          <b>Billing Term End Date:</b> {baseHelper.formatDate(plan.paye.endTermDate)}
                        </List.Item>
                      </List>
                      <br />
                      {/* <Card.Section title="Note*"> */}
                      <b>Note*</b>
                      <List type="bullet">
                        <List.Item>
                          Calculated on the basis of
                          {plan.paye.orderCount}{" "}
                        </List.Item>
                        <List.Item>Calculated as 3% of the total order value within the billing term.</List.Item>
                      </List>
                      {/* </Card.Section> */}
                    </div>
                  )}
                  {!isPAYE && <Text variant="headingMd" as="p">{`$${price}/m`}</Text>}
                </InlineStack>
              </div>

              {!isPAYE && [
                <div className="stack-wrapper count">
                  <InlineStack align="space-between">
                    <Text as="span">{cms("common.label.tabs.operator.products")}</Text>
                    <Text as="span" tone="subdued">{`${used}/${maxProduct}`}</Text>
                  </InlineStack>
                  <ProgressBar progress={(used / maxProduct) * 100} size="small" />
                  {/* <ProgressBar progress={76} size="small" /> */}
                </div>,
                <div className="stack-wrapper count">
                  <InlineStack align="space-between">
                    <Text as="span">{cms("common.label.tabs.operator.providers")}</Text>
                    <Text as="span" tone="subdued">{`${associated}/${maxVendor}`}</Text>
                  </InlineStack>
                  <ProgressBar progress={(associated / maxVendor) * 100} size="small" />
                </div>,
              ]}
              <div className="upgrade-button">
                <Button
                  variant="primary"
                  fullWidth
                  url={currentUser.isTest ? config.stripePortal("uat") : config.stripePortal()}
                >
                  Manage your billing
                </Button>
              </div>
              <br />
              {/* <Tooltip preferredPosition="below" hoverDelay={400} content="Contact us to upgrade your plan">
                <div className="upgrade-button">
                  <Button variant="primary" fullWidth>
                    {cms("common.button.upgrade")}
                  </Button>
                </div>
              </Tooltip> */}
              {/* <br />
                <div className="upgrade-button">
                  <Tooltip content="Contact us to upgrade your plan">
                    <Button variant="primary" fullWidth>
                      url={planURL}
                      {cms("common.button.upgrade")}
                    </Button>
                  </Tooltip>
                </div> */}
            </InnerCard>
          </Collapsible>
          {/* </StyledPlanCard> */}
        </Card>
        <br />
      </ThemeProvider>
    </AppProvider>
  );
};

export default OperatorPlanCard;
